import { render } from "./StepDetails.vue?vue&type=template&id=4c68dc74&ts=true"
import script from "./StepDetails.ts?vue&type=script&lang=ts"
export * from "./StepDetails.ts?vue&type=script&lang=ts"

import "./StepDetails.vue?vue&type=style&index=0&id=4c68dc74&scope=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__